// Tokens will be managed here
let accessToken = null;
let refreshToken = null;

export const setAccessToken = (token) => {
  accessToken = token;
};

export const setRefreshToken = (rToken) => {
  refreshToken = rToken;
};

export const getAccessToken = () => accessToken;

export const getRefreshToken = () => refreshToken;

export const isTokenExpiredAccessToken = () => {
  try {
    const expiryTime = localStorage.getItem('authKeyExpiredAt') || null;
    return Date.now() >= expiryTime * 1000;
  } catch (error) {
    console.error('Error decoding token:', error);
    return true;
  }
};

export const isTokenExpiredRefreshToken = () => {
  try {
    const expiryTime = localStorage.getItem('refreshTokenExpiredAt') || null;
    return Date.now() >= expiryTime * 1000;
  } catch (error) {
    console.error('Error decoding token:', error);
    return true;
  }
};

// Function to initialize tokens from Redux
export const initializeTokens = (authState) => {
  accessToken = authState?.token || null;
  refreshToken = authState?.refreshToken || null;
};
